<template>
  <div class="color-card-container">
    <div class="nav-section">
      <!-- 左侧：网格按钮菜单（menulist） -->
      <div class="button-row">
        <el-button
          class="menu-btn"
          v-for="(item, index) in menulist"
          :key="index"
          @click="
            handleMenuClick(
              item.content,
              `/publish-clothes/colorcard/${item.name}`
            )
          "
        >
          {{ item.content }}
        </el-button>
      </div>

      <!-- 中间：列表式菜单（menulists 里的部分项） -->
      <div class="list-row">
        <a
          href="javascript:void(0)"
          v-for="(item, index) in listMenu"
          :key="index"
          class="menu-link list-item"
          @click="
            handleMenuClick(
              item.content,
              `/publish-clothes/colorcard/${item.name}`
            )
          "
        >
          <img :src="srcs" style="width: 23px; height: 18px" alt="" />
          {{ item.content }}
        </a>
      </div>

      <!-- 右侧：下划线式菜单（menulists 里的剩余项） -->
      <div class="report-row">
        <a
          href="javascript:void(0)"
          v-for="(item, index) in reportMenu"
          :key="index"
          class="menu-link report-item"
          @click="
            handleMenuClick(
              item.content,
              `/publish-clothes/colorcard/${item.name}`
            )
          "
        >
          <img :src="srcss" style="width: 23px; height: 18px" alt="" />
          {{ item.content }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import src from "/src/views/front/colorcards/20.png";
import ssrc from "/src/views/front/colorcards/21.png";
export default {
  name: "ColorCardMenu",
  data() {
    return {
      srcs: src,
      srcss: ssrc,
      menulist: [], // 网格按钮菜单
      menulists: [], // 列表+报表菜单（id=12,13,14）
    };
  },
  computed: {
    // 中间列表菜单：商品列表、客户列表（id=12、13）
    listMenu() {
      return this.menulists.filter((item) => item.id === 14 || item.id == 20);
    },
    // 右侧报表菜单：色卡板查询报表（id=14）
    reportMenu() {
      return this.menulists.filter(
        (item) =>
          item.id === 12 || item.id === 13 || item.id === 19 || item.id === 22
      );
    },
  },
  mounted() {
    this.users();
  },
  methods: {
    ...mapActions(["addMenuClickRecord"]),
    handleMenuClick(title, path) {
      console.log(title, path, "返回的对不对");
      this.addMenuClickRecord({ title, path });
      this.$router.push(path);
    },
    async users() {
      try {
        const res = await this.$api.My.gets({});
        this.menulist =
          res?.data?.data.list
            .filter((item) => item.content == "色卡管理")[0]
            .childrenList.filter(
              (item) =>
                item.id !== 12 &&
                item.id !== 13 &&
                item.id !== 14 &&
                item.id !== 19 &&
                item.id !== 20 &&
                item.id !== 22
            ) || [];
        this.menulists =
          res?.data?.data.list
            .filter((item) => item.content == "色卡管理")[0]
            .childrenList.filter(
              (item) =>
                item.id == 12 ||
                item.id == 13 ||
                item.id == 14 ||
                item.id == 19 ||
                item.id == 20 ||
                item.id == 22
            ) || [];
        console.log(this.menulist, this.menulists, "返回了什么");
      } catch (error) {
        console.error("获取菜单列表失败：", error);
        this.menulist = [];
        this.menulists = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.color-card-container {
  width: 100%;
  min-height: 100%;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
}

.nav-section {
  display: flex;
  align-items: flex-start;
  gap: 80px;
}

/* 左侧：网格按钮 */
.button-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 30px;
  padding-top: 50px;
}

.menu-btn {
  width: 150px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  margin: 0;

  &:hover {
    background-color: #f9f9f9;
  }
}

/* 中间：列表菜单（带图标） */
.list-row {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.list-item {
  color: #333;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;

  i {
    margin-right: 6px;
  }
}

/* 右侧：下划线菜单 */
.report-row {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.report-item {
  color: #333;
  font-size: 14px;
  text-decoration: none;
  border-bottom: 2px solid #333;
  padding-bottom: 4px;
  cursor: pointer;
}

/* 响应式适配 */
@media screen and (max-width: 1100px) {
  .button-row {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 992px) {
  .button-row {
    grid-template-columns: repeat(2, 1fr);
  }
  .nav-section {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
  .list-row,
  .report-row {
    padding-top: 0;
  }
}
@media screen and (max-width: 720px) {
  .button-row {
    grid-template-columns: 1fr;
  }
}
</style>